<div class="cb-entity-documentation-editor">
    <!-- Loading State -->
    @if (loading) {
        <div class="loading-state">
            <p-progressSpinner strokeWidth="4"></p-progressSpinner>
            <span>Loading documentation...</span>
        </div>
    }

    <!-- Editor Form -->
    @if (!loading && entity) {
        <div class="editor-content">
            <!-- Entity Info -->
            <div class="entity-info">
                <div class="entity-header">
                    <i class="fa-regular fa-database"></i>
                    <div class="entity-details">
                        <span class="entity-name">{{ entity.entityName }}</span>
                        <span class="entity-alias">{{ entity.objectTypeAlias }}</span>
                    </div>
                </div>

                <div class="entity-stats">
                    <div class="stat">
                        <span class="stat-value">{{ entity.documentedAttributes }}/{{ entity.totalAttributes }}</span>
                        <span class="stat-label">Attributes Documented</span>
                    </div>
                    <div class="stat">
                        <span class="stat-value" [class.documented]="entity.isDocumented">
                            {{ entity.isDocumented ? 'Yes' : 'No' }}
                        </span>
                        <span class="stat-label">Entity Documented</span>
                    </div>
                </div>
            </div>

            <!-- Form -->
            <form [formGroup]="form" class="documentation-form">
                <!-- Business Description -->
                <div class="form-field">
                    <label for="businessDescription">
                        Business Description <span class="required">*</span>
                    </label>
                    <textarea
                        id="businessDescription"
                        pInputTextarea
                        formControlName="businessDescription"
                        rows="5"
                        placeholder="Describe what this entity represents in business terms..."
                        [autoResize]="true">
                    </textarea>
                    <small class="field-hint">
                        Explain the entity's purpose and role in the business domain.
                    </small>
                </div>

                <!-- Usage Notes -->
                <div class="form-field">
                    <label for="usageNotes">Usage Notes</label>
                    <textarea
                        id="usageNotes"
                        pInputTextarea
                        formControlName="usageNotes"
                        rows="3"
                        placeholder="Add any notes about how this entity is typically used..."
                        [autoResize]="true">
                    </textarea>
                    <small class="field-hint">
                        Common use cases, relationships with other entities, best practices.
                    </small>
                </div>

                <!-- Domain Context -->
                <div class="form-field">
                    <label for="domainContext">Domain Context</label>
                    <input
                        id="domainContext"
                        type="text"
                        pInputText
                        formControlName="domainContext"
                        placeholder="e.g., Customer Management, Contract Processing">
                    <small class="field-hint">
                        The business domain or functional area this entity belongs to.
                    </small>
                </div>
            </form>

            <!-- Actions -->
            <div class="editor-actions">
                <p-button
                    label="Cancel"
                    [text]="true"
                    severity="secondary"
                    (onClick)="cancel()">
                </p-button>
                <p-button
                    label="Save Documentation"
                    icon="fa-regular fa-save"
                    (onClick)="save()"
                    [loading]="saving"
                    [disabled]="!form.valid || saving">
                </p-button>
            </div>
        </div>
    }
</div>
